import { NewsletterStatus } from '@spa/generated/graphql/graphql';

export enum NewsletterRegistrationFormStatus {
  INITIAL = 'INITIAL',
  SUBMITTING = 'SUBMITTING',
  SUBMITTED = 'SUBMITTED'
}

export const getNewsletterRegistrationErrorKey = (erroredStatus: NewsletterStatus): string => {
  let errorKey: string;

  if (
    erroredStatus === NewsletterStatus.DUPLICATE ||
    erroredStatus === NewsletterStatus.HAS_ACTIVE_SUBSCRIPTION
  ) {
    errorKey = 'duplicatedUser';
  } else if (erroredStatus === NewsletterStatus.WERBESPERRUNG) {
    errorKey = 'werbesperrungError';
  } else {
    errorKey = 'formError';
  }

  return errorKey;
};
